module.exports = __webpack_public_path__ + "img/1f321d5.svg";